import { DateTime } from "luxon";

import i18n from "../../i18n";
import type { Warning } from "../../i18n/serverMessages";

export enum MeterType {
  Percussion = 1,
  Compressor = 2,
  Rotation = 3,
  Tramming = 4,
}

export interface RigServiceDueDTO {
  plantId: number;
  plantRef: string;
  meterType: MeterType;
  serviceIntervalHours: number;
  hoursToService: number | null;
  lastServiceOn: DateTime | null;
}

export const METER_LABELS: Record<MeterType, string> = {
  get [MeterType.Percussion]() { return i18n.t("meter.percussion", { ns: "drillBlast" }); },
  get [MeterType.Compressor]() { return i18n.t("meter.compressor", { ns: "drillBlast" }); },
  get [MeterType.Rotation]() { return i18n.t("meter.rotation", { ns: "drillBlast" }); },
  get [MeterType.Tramming]() { return i18n.t("meter.tramming", { ns: "drillBlast" }); },
};

export interface OperationMeterDTO {
  meterType: MeterType;
  startReading?: number | null;
  endReading?: number | null;
  startCarriedForward: boolean;
  hours?: number | null;
  meterReplaced: boolean;
  notes?: string | null;
  rowVersion?: string | null;
  serviceIntervalHours?: number | null;
  lastServiceOn?: DateTime | null;
  hoursToService?: number | null;
  warnings: Warning[];
}

export interface RigMetersDTO {
  operationId: number;
  plantId: number;
  plantRef: string;
  shiftId: number;
  shiftDate: DateTime;
  engineStart?: number | null;
  engineEnd?: number | null;
  meters: OperationMeterDTO[];
}

export interface PlantMeterDTO {
  meterType: MeterType;
  serviceIntervalHours?: number | null;
  lastServiceReading?: number | null;
  lastServiceOn?: DateTime | null;
  isActive: boolean;
  configured: boolean;
}

export interface PlantMeterSetting {
  meterType: MeterType;
  serviceIntervalHours?: number | null;
  isActive: boolean;
}

export interface SaveOperationMeterRequest {
  startReading?: number | null;
  endReading?: number | null;
  meterReplaced: boolean;
  notes?: string | null;
  rowVersion?: string | null;
}
